import { ArrowUpRight } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function TransferNode({ id, data, selected }) {
  const summary = data.toAddress
    ? `${data.amount || '?'} ${data.token || 'ETH'} → ${data.toAddress.slice(0, 8)}...`
    : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallet}
      icon={ArrowUpRight}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
